.verifyEmail .iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyEmail .icon {
  margin-right: var(--cxy-spacing-2);
  margin-bottom: var(--cxy-spacing-6);
  color: var(--cxy-color-brand);
}
.verifyEmail .title {
  font-size: var(--cxy-fontSize-xxl);
  font-weight: bold;
  display: flex;
  align-items: center;
  color: var(--cxy-color-content-default);
}
.verifyEmail .content {
  display: flex;
  flex-direction: column;
  gap: var(--cxy-spacing-2);
}
.verifyEmail .text {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-default);
}
